import { render, staticRenderFns } from "./StatisticsByTrend.htm?vue&type=template&id=4f54e6dc&scoped=true&"
import script from "./StatisticsByTrend.ts?vue&type=script&lang=js&"
export * from "./StatisticsByTrend.ts?vue&type=script&lang=js&"
import style0 from "./StatisticsByTrend.scss?vue&type=style&index=0&id=4f54e6dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54e6dc",
  null
  
)

export default component.exports